import React from 'react';
import './TemplateButton.scss';



export type TemplateButtonProps = {
  theme?: string;
  title: string;
  text: string;
  iconLeft?: JSX.Element;
  iconRight?: JSX.Element;
  handleClick: () => void;
};

const TemplateButton = ({
  theme,
  title,
  text,
  iconLeft,
  iconRight,
  handleClick
}: TemplateButtonProps) => {
  return (
    <div 
      className="template-button" 
      data-theme={theme}
      onClick={handleClick}
    >
      {iconLeft ? iconLeft : <span></span>}
      <div className="template-button__content">
        <div className="template-button__content__title">
          { title }
        </div>
        <div className="template-button__content__desc">
          { text }
        </div>
      </div>
      {iconRight ? iconRight : <span></span>}
    </div>
  );
};

export default TemplateButton;
